import type {Endpoints} from "@hosttools/web/server/routes/routes.messageRules.types";
import type {AxiosRequestConfig} from "axios";

import type {LanguageCode} from "../../constant/languages";
import type {MessageRule} from "../../models/messageRule";
import type {UploadFilePayload} from "../../utils/file";
import {generateImageUploadFormData} from "../../utils/file";
import {Base} from "../base";

interface DeleteImagePayload {
    messageRuleID: string;
    keys: string[];
}

export type MessageRuleCustom = MessageRule & {type: string};

class MessageRuleService extends Base<Endpoints> {
    async deleteImagesFromMessageRule(
        {messageRuleID, keys}: DeleteImagePayload,
        config?: AxiosRequestConfig
    ) {
        const url = "/deleteImagesMessageRule";
        const result = await this.post(
            url,
            {
                messageRuleID,
                keys
            },
            config
        );

        return result;
    }

    async addImageMessageRule(
        {messageRuleID, ...rest}: UploadFilePayload<{messageRuleID: string}>,
        config?: AxiosRequestConfig
    ) {
        const url = "/addImageMessageRule";
        const formData = generateImageUploadFormData(rest);
        formData.append("messageRuleID", messageRuleID);

        const {data} = await this.http.post(url, formData, {
            headers: {"Content-Type": "multipart/form-data"},
            ...config,
            // this fixes to send form for 0.x version
            transformRequest: data => data
        });

        return data;
    }

    async getMessageRules() {
        const url = "/getMessageRules";
        const result = await this.get(url);
        return result;
    }

    async previewMessage(language: LanguageCode, value: string) {
        const url = "/previewMessageRule";
        const result = await this.post(url, {
            preferredLocale: language !== "default" ? language : undefined,
            messages: {
                default: value,
                [language]: value
            }
        });
        return result.message;
    }
}

export default MessageRuleService;
